export default __webpack_public_path__ + "static/media/background.f05d99f5.png";